import { httpsCallable } from "firebase/functions"
import { functions } from "@/config/firebase"

const DEFAULT_PRODUCT_VIDEO_PROMPT =
  "Create a short cinematic product showcase video with smooth camera movement, clean studio lighting, and premium e-commerce styling. Keep product shape, color, and texture consistent across frames."

interface GenerateProductVideoRequest {
  prompt?: string
  imageUrls?: string[]
  aspectRatio?: string
}

interface GenerateProductVideoResponse {
  videoUrl: string
  filePath: string
  mimeType: string
  model: string
}

const generateProductVideo = async (payload: GenerateProductVideoRequest): Promise<GenerateProductVideoResponse> => {
  const callable = httpsCallable<GenerateProductVideoRequest, GenerateProductVideoResponse>(
    functions,
    "generateProductVideo"
  )
  const result = await callable(payload)
  return result.data
}

export { generateProductVideo, DEFAULT_PRODUCT_VIDEO_PROMPT }
export type { GenerateProductVideoRequest, GenerateProductVideoResponse }
